module.exports = __webpack_public_path__ + "static/media/Safety.f84147a5.png";